import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
    description: {
        '& code': {
            padding: 20,
            borderRadius: 18,
            background: '#38383A',
            fontSize: 13,
            lineHeight: '15px'
        }
    },
    head: {
        fontSize: 24,
        fontWeight: 700
    },
    body: {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        fontSize: 14,
        fontWeight: 300,
        lineHeight: '25px',
        transition: 'all 0.6s ease-out',
        overflow: 'hidden',
        a: {
            color: theme.palette.primary.main,
            textDecoration: 'none'
        },
        img: {
            maxWidth: '100%'
        },
        code: {
            wordWrap: 'break-word',
            whiteSpace: 'normal'
        },
        ul: {
            maxHeight: 300,
            overflowY: 'scroll',
            scrollbarWidth: 'none', // Firefox
            '&::-webkit-scrollbar': {
                display: 'none' // Safari and Chrome
            }
        }
    },
    more: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&>p, >svg': {
            fontWeight: 600,
            color: theme.palette.primary.main
        }
    },
    icon: {
        transition: 'all 0.3s ease-out'
    },
    mask: {
        maskImage: 'linear-gradient(to top, transparent 0%, black 18%)'
    },
    added: {
        background: '#E5F6ED'
    },
    removed: {
        background: '#FFEBED'
    }
}));
